<div *ngIf="statuses?.length" class="load-track-graph">
  <div *ngFor="let status of statuses" class="load-track-item" [ngClass]="status.acceptanceType | lowercase">
    <div class="load-track-item__line-container" [class.not_received]="status.hide"></div>
    <ui-svg-icon [name]="sCodeIcons.get(status.statusCode)" class="load-track-item__icon"></ui-svg-icon>
    <div class="status-info">
      <div class="status-info__description">
        {{ status.statusDescription }}
        <ui-tooltip-alert
          *ngIf="status?.latestNotification?.reason"
          [tooltipText]="status?.latestNotification?.reason"
          class="status-info__icon"
        ></ui-tooltip-alert>
      </div>
      <div class="status-info__address">
        {{ status.address }}
      </div>
      <div class="status-info__date">
        {{
          status.acceptanceType === acceptanceType.NotReceived && status.assignedDateTime
            ? ('load.status.expectedAt' | translate) + ': '
            : null
        }}
        <ui-date-with-timezone [localDate]="status?.assignedDateTime"></ui-date-with-timezone>
      </div>
    </div>
  </div>
</div>
